import {
  pricingTranslationsFr,
  featuresSectionFr,
  footerExtendedFr,
  organizationsFr,
  b2bContactFr,
  signInFr,
  a11yFr,
} from './marketingCopy.fr'
import { accountAdminCopyFr } from './accountAdminCopy/accountAdminCopy.fr'

export const fr = {
  hero: {
    title: 'Zporti',
    subtitle: 'Défiez vos Amis. Prédisez le Match. Gagnez Ensemble.',
    description:
      'Créez des défis de prédictions sportives avec vos amis, suivez vos victoires et participez au classement. La plateforme ultime pour la compétition amicale et les prédictions sportives.',
  },
  siteNav: {
    home: 'Accueil',
    organizations: 'Organisations',
    contact: 'Contact',
    packs: 'Tarifs',
    signIn: 'Connexion',
    createAccount: 'S’inscrire',
    openApp: 'Ouvrir l’app',
    signedInAs: 'Connecté·e en tant que',
    signedInNameFallback: 'Votre compte',
    signOut: 'Se déconnecter',
    signOutConfirmTitle: 'Se déconnecter ?',
    signOutConfirmMessage: 'Vous devrez vous reconnecter pour accéder à votre compte.',
    signOutConfirm: 'Se déconnecter',
    signOutCancel: 'Annuler',
    signOutErrorTitle: 'Erreur',
    signOutError: 'Impossible de se déconnecter. Réessayez.',
  },
  features: {
    title: 'Pourquoi Zporti?',
    subtitle: 'Tout ce dont vous avez besoin pour transformer les prédictions sportives en compétition amicale',
    challenge: {
      title: 'Défier des Amis',
      description:
        'Créez des défis de prédiction personnalisés et invitez vos amis à participer. Organisez des défis de groupe ou affrontez-vous individuellement.',
    },
    track: {
      title: 'Suivre les Résultats',
      description:
        'Consultez les scores en temps réel, suivez vos prédictions et surveillez votre taux de victoire. Recevez des notifications instantanées lorsque les résultats des matchs arrivent.',
    },
    compete: {
      title: 'Competir et Gagner',
      description:
        'Grimpez au classement, gagnez des droits de vantardise et découvrez qui est le meilleur prédicteur. Célébrez les victoires et suivez vos progrès dans le temps.',
    },
    groups: {
      title: 'Groupes & saisons',
      description:
        'Gardez la même équipe d’amis d’une journée de match à l’autre, comparez les classements de groupe et lancez des défis façon mini-championnat, pas ponctuels.',
    },
    locks: {
      title: 'Pronostics avant le coup d’envoi',
      description:
        'Les pronostics se verrouillent au début du match : mêmes règles pour tout le monde. Les résultats suivent les scores officiels—équitables et sans discussion.',
    },
    organizations: {
      title: 'Organisations & image de marque',
      description:
        'Clubs, entreprises et partenaires peuvent afficher leurs couleurs, logos et sièges membres—votre communauté vous ressemble dans l’app.',
    },
    avatars: featuresSectionFr.avatars,
  },
  featuresSection: featuresSectionFr,
  howItWorks: {
    title: 'Comment ça Marche',
    subtitle: 'Commencez en trois étapes simples',
    step1: {
      title: 'Créer un Défi',
      description: 'Choisissez un match, définissez vos prédictions et invitez des amis à rejoindre votre défi.',
    },
    step2: {
      title: 'Faire des Prédictions',
      description:
        'Chaque participant fait ses prédictions avant le début du match. Verrouillez vos choix et attendez l\'action.',
    },
    step3: {
      title: 'Voir Qui Gagne',
      description:
        'Les résultats sont calculés automatiquement à la fin des matchs. Célébrez les victoires et grimpez au classement.',
    },
  },
  competition: {
    title: 'Compétition Amicale, Excitement Réel',
    description:
      'Vivez le frisson des prédictions sportives avec vos amis. Que vous soyez un fan occasionnel ou un passionné de statistiques, Zporti rend chaque match plus excitant. Défiez vos amis, prouvez vos compétences de prédiction et voyez qui sort vainqueur.',
  },
  stats: {
    challenges: 'Défis Actifs',
    users: 'Utilisateurs Actifs',
    predictions: 'Prédictions Effectuées',
    games: 'Matchs Suivis',
  },
  benefits: {
    title: 'Pourquoi Choisir Zporti?',
    subtitle: 'Tout ce dont vous avez besoin pour l\'expérience ultime de prédictions sportives',
    realTime: {
      title: 'Mises à Jour en Temps Réel',
      description:
        'Recevez des notifications instantanées lorsque les matchs commencent, les scores se mettent à jour et les résultats arrivent. Ne manquez jamais un moment avec le suivi des scores en direct et les calculs automatiques des résultats.',
    },
    social: {
      title: 'Social et Connecté',
      description:
        'Connectez-vous avec des amis via Gmail, invitez-les facilement et construisez votre réseau de prédictions. Créez des défis de groupe ou affrontez-vous individuellement avec vos amis les plus proches.',
    },
    smart: {
      title: 'Prédictions Intelligentes',
      description:
        'Suivez les cotes, analysez les données des matchs et faites des prédictions éclairées. Consultez les performances historiques, les taux de victoire et les statistiques détaillées pour améliorer vos compétences de prédiction.',
    },
    fair: {
      title: 'Juste et Transparent',
      description:
        'Tous les résultats sont calculés automatiquement à la fin des matchs. Pas de disputes, pas de notation manuelle - juste une compétition équitable et des gagnants clairs.',
    },
  },
  faq: {
    title: 'Questions Fréquemment Posées',
    subtitle: 'Tout ce que vous devez savoir sur Zporti',
    q1: {
      question: 'Comment inviter des amis?',
      answer:
        'Vous pouvez inviter des amis de deux façons: connectez votre compte Gmail pour sélectionner facilement des contacts, ou entrez manuellement des adresses e-mail. Les amis recevront un lien d\'invitation pour rejoindre votre défi.',
    },
    q2: {
      question: 'Quand les prédictions sont-elles verrouillées?',
      answer:
        'Les prédictions doivent être faites avant le début du match. Une fois qu\'un match commence, toutes les prédictions sont verrouillées et ne peuvent pas être modifiées. Cela garantit une compétition équitable pour tous.',
    },
    q3: {
      question: 'Comment les gagnants sont-ils déterminés?',
      answer:
        'Les gagnants sont calculés automatiquement à la fin des matchs. Le système compare toutes les prédictions aux résultats réels des matchs et met à jour les classements en temps réel.',
    },
    q4: {
      question: 'Puis-je créer des défis de groupe?',
      answer:
        'Oui! Vous pouvez créer des défis avec plusieurs amis ou affronter individuellement des amis. Organisez des compétitions de groupe pour voir qui a les meilleures compétences de prédiction.',
    },
  },
  packsPage: {
    pageTitle: 'Plans & Tarifs',
  },
  contact: {
    title: 'Nous contacter',
    subtitle:
      'Questions produit, retours, presse ou partenariats—écrivez-nous ci-dessous ou par e-mail. Nous lisons chaque message.',
    emailLabel: 'Envoyez-nous un e-mail à',
    email: 'info@zporti.com',
    form: {
      nameLabel: 'Nom',
      emailLabel: 'E-mail',
      messageLabel: 'Message',
      submitButton: 'Envoyer le Message',
      submitting: 'Envoi en cours...',
      successMessage: 'Merci! Votre message a été envoyé. Nous vous répondrons bientôt.',
      errorMessage: 'Échec de l\'envoi du message. Veuillez réessayer plus tard.',
      namePlaceholder: 'Prénom et nom',
      emailPlaceholder: 'votre.email@exemple.com',
      messagePlaceholder: 'Dites-nous ce qui vous préoccupe...',
      validation: {
        nameRequired: 'Le nom est obligatoire',
        nameTooLong: 'Le nom doit contenir 50 caractères ou moins',
        emailRequired: 'L\'e-mail est obligatoire',
        emailInvalid: 'Veuillez entrer une adresse e-mail valide',
        messageRequired: 'Le message est obligatoire',
        messageTooLong: 'Le message doit contenir 500 caractères ou moins',
        invalidCharacters: 'Caractères invalides détectés. Veuillez supprimer toute mise en forme spéciale.',
      },
    },
  },
  footer: {
    title: 'Prêt à Commencer?',
    subtitle:
      'Rejoignez Zporti aujourd\'hui et commencez à défier vos amis. Créez votre premier défi de prédiction en quelques secondes.',
    privacyPolicy: 'Politique de confidentialité',
    termsOfService: "Conditions d'utilisation",
    dataDeletion: 'Suppression des données',
    credits: 'Crédits',
    privacyControls: 'Contrôles de confidentialité',
    ...footerExtendedFr,
  },
  pricing: pricingTranslationsFr,
  organizations: organizationsFr,
  b2bContact: b2bContactFr,
  signIn: signInFr,
  a11y: a11yFr,
  accountAdmin: accountAdminCopyFr,
  legal: {
    backToHome: "Retour à l'accueil",
    backToPrivacyAndData: 'Retour',
    privacyDocumentTitle: 'Politique de confidentialité',
    dataDeletionDocumentTitle: 'Instructions de suppression des données',
    termsDocumentTitle: "Conditions d'utilisation",
    creditsDocumentTitle: 'Crédits',
    aboutDocumentTitle: 'À propos de Zporti',
    supportDocumentTitle: 'Assistance',
    documentVersionLine: 'Dernière mise à jour {date} · version {version}',
    privacyControlsCallout:
      'Vous voulez modifier vos consentements ou demander une copie de vos données ? Ouvrez les contrôles de confidentialité dans votre compte.',
    openPrivacyControls: 'Ouvrir les contrôles de confidentialité',
    signInForPrivacyControls: 'Connectez-vous pour ouvrir les contrôles de confidentialité',
  },
  privacyControls: {
    title: 'Contrôles de confidentialité',
    subtitle: 'Gérez le consentement marketing et demandez une copie des données de votre compte.',
    marketingEmailsTitle: 'E-mails marketing',
    marketingEmailsHint: 'Vous pouvez activer ou retirer votre consentement à tout moment.',
    analyticsTrackingTitle: 'Suivi analytique',
    analyticsTrackingHint: 'Activez ou désactivez le suivi analytique pour cet appareil/navigateur.',
    accountDataCopyTitle: 'Copie des données du compte',
    accountDataCopyHint:
      'Téléchargez une copie JSON des données personnelles liées à votre compte (disponible une fois toutes les 24 heures).',
    enabled: 'Activé',
    disabled: 'Désactivé',
    downloadMyData: 'Télécharger mes données',
    nextExportAvailable: 'Prochaine exportation disponible',
    close: 'Fermer',
    deleteYourAccount: 'Supprimer votre compte',
    deleteYourAccountHint:
      "Continuez pour confirmer à l'écran suivant. Cela supprime définitivement votre compte et les données associées.",
  },
}

